/**
 * Created by Jonathan on 20/03/2018.
 */
import http from '@/utils/services/http'

export default {
  find (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/documento/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastro (data, id) {
    if (typeof id !== 'undefined') {
      return this.atualizacao(data, id)
    }
    return http.post('/api/documento/', data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizacao (data, id) {
    return http.patch('/api/documento/' + id, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getDocumentoList () {
    return http.get('/api/documento/')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  lista (limit, page, filtros) {
    let url = '/api/documento?page=' + page + '&limit=' + limit + filtros
    return http.get(url)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteDocumento (id) {
    return http.delete('/api/documento/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteDocumentoList (ids) {
    return http.delete('/api/documento/deleteList', {data: {data: ids}})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  importar (data, cbUploadProgress) {
    return http.post('/api/documento/importar', data, {headers: {'Content-Type': 'multipart/form-data'}, onUploadProgress: cbUploadProgress})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/documento/services/documento.js